var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"pageHeader",style:({color: _vm.color === 'black' ? '#2E2F34' : '#fff' }),attrs:{"v-html":_vm.text}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }